"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  shell: {
    componentTitle: 'Configurazioni di adempimento',
    incompletePropsMessage: "Non sono state fornite informazioni sufficienti, compila tutti i campi richiesti per l'ordine di prova."
  },
  selectedConfigurationDisplay: {
    selectedConfigurationLabel: 'CONFIGURAZIONE SELEZIONATA:',
    noSelectedConfigurationLabel: 'Seleziona una configurazione:',
    clearButton: 'Selezione chiara'
  },
  fulfillmentConfigurationList: {
    actions: {
      error500: "Si è verificato un errore durante il recupero dell'elenco delle configurazioni di esecuzione." + ' Puoi premere Riprova per vedere se viene risolto.',
      permissionsError: 'Sembra che tu non disponga delle autorizzazioni per visualizzare queste configurazioni di esecuzione.' + " Contatta l'assistenza della piattaforma per ottenere l'accesso.",
      unknownError: 'Si è verificato un errore sconosciuto. Per favore riprova.'
    },
    table: {
      nameHeader: 'Nome configurazione adempimento'
    },
    selectVersionButton: 'Seleziona la versione'
  },
  fulfillmentConfigurationErrorPage: {
    noAvailableFulfillmentConfigurations: {
      titleText: 'Non sono disponibili configurazioni di esecuzione per questo prodotto.',
      productAssociationsSuggestion: 'Controlla il tuo ',
      productAssociationsLink: 'Associazioni di prodotto',
      fulfillmentConfigurationsSuggestion: 'Crea un nuovo ',
      fulfillmentConfigurationsLink: "Configurazione dell'adempimento",
      emailSuggestion: 'Hai bisogno di più supporto? Contatto ',
      emailLink: 'platformsupport@cimpress.com',
      tryAgainText: 'Hai fatto dei cambiamenti? Fare clic qui per riprovare.'
    },
    error: {
      errorTitle: 'Si è verificato un errore durante il caricamento delle configurazioni di evasione'
    },
    reloadButtonText: 'Ricaricare'
  },
  search: {
    searchFieldLabel: 'Configurazioni di ricerca'
  },
  versionsList: {
    table: {
      moreInfoButton: 'Ulteriori informazioni',
      rowContentsHeader: 'Versione',
      noVersionsText: 'Nessuna versione trovata'
    },
    backButton: 'Indietro'
  }
};
exports["default"] = _default;